import { render, staticRenderFns } from "./PhotoOverview.vue?vue&type=template&id=c4f53056&"
import script from "./PhotoOverview.vue?vue&type=script&lang=ts&"
export * from "./PhotoOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PhotoOverview.vue"
export default component.exports